import { render } from "./QuestionDataList.vue?vue&type=template&id=3b445812&scoped=true"
import script from "./QuestionDataList.vue?vue&type=script&lang=js"
export * from "./QuestionDataList.vue?vue&type=script&lang=js"

import "./QuestionDataList.vue?vue&type=style&index=0&id=3b445812&lang=scss&scoped=true"
import "./QuestionDataList.vue?vue&type=style&index=1&id=3b445812&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b445812"]])

export default __exports__